import { TagModel } from "@verivest/shared-components/src/api/models";
import { JsonApiManyResponse } from "@verivest/shared-components/src/api/types";
import { useToastError } from "@verivest/shared-components/src/hooks/ui/toast/useToastError";
import useSWR from "swr";

export const useDocumentsTags = () => {
  const toastError = useToastError();
  const { data: tagsData, error } = useSWR<JsonApiManyResponse<TagModel>>(
    "/tags?tag_type=Document&sort=name",
    {
      focusThrottleInterval: 0,
    },
  );

  if (error) {
    toastError(error);
  }

  return tagsData?.data.reduce(
    (all: Record<string, string | undefined>, tag: TagModel) => ({
      ...all,
      [tag.name || ""]: String(tag.id),
    }),
    {},
  );
};
